import React, {useState, useEffect} from 'react';
import S from 'StyledAccountFreebet.js';
import Loader from 'Loader.js';
import {useDispatch, batch} from 'react-redux';
import {bindActionCreators} from 'redux';
import {translation} from 'utilsHelper.js';
import Pagination from 'Pagination.js';
import _map from 'lodash/map';
import _size from 'lodash/size';
import _get from 'lodash/get';
import {formatDate} from 'datesHelper.js';
import {connect} from 'react-redux';
import {
    changeDateByType,
    fetchFreebetsByFilter,
    setCurrentPage,
    changeActiveTab,
    resetToInitialState
} from 'accountFreebetActions.js';

const AccountFreebet = (props) => {
    const {isPending, activeTab, freebets, limit} = props;
    const activeFreebets = _get(freebets, 'active');
    const historyFreebets = _get(freebets, 'history');
    const activeFreebetsData = _get(activeFreebets, 'data');
    const historyFreebetsData = _get(historyFreebets, 'data');

    const [calendarStartDate, setCalendarStartDate] = useState(formatDate(new Date, 'yyyy-MM-dd'));
    const [calendarEndDate, setCalendarEndDate] = useState(formatDate(new Date, 'yyyy-MM-dd'));

    const dispatch = useDispatch();

    useEffect(() => {
        fetchFreebets();

        return () => {
            const {resetToInitialState} = props;
            resetToInitialState();
        }
    }, []);

    const fetchFreebets = async () => {
        try {
            await dispatch(fetchFreebetsByFilter());
    
        } catch (error) {
            console.log('fetchFreebetByFilter:' + error);
        }
    };

    const onChangeFilter = (activeTab) => {
        const {changeActiveTab, fetchFreebetsByFilter} = props;
        batch(() => {
            changeActiveTab(activeTab);
            fetchFreebetsByFilter();
        })
    };

    const handleChangeStart = (date) => {
        const {changeDateByType, fetchFreebetsByFilter} = props;
        const startDate = new Date(date);

        setCalendarStartDate(date);
        
        batch(() => {
            changeDateByType('startDate', startDate);
            fetchFreebetsByFilter();
        })
    };

    const handleChangeEnd = (date) => {
        const {changeDateByType, fetchFreebetsByFilter} = props;
        const endDate = new Date(date);

        setCalendarEndDate(date);

        batch(() => {
            changeDateByType('endDate', endDate);
            fetchFreebetsByFilter();
        })
    };

    const goPage = (currentPage) => {
        const {fetchFreebetsByFilter, setCurrentPage} = props;
        try {
            batch(() => {
                setCurrentPage(currentPage);
                fetchFreebetsByFilter();
            })
        } catch (error) {
            console.log('goPage:' + error);
        }
    };
    
    return (
        <S.AccountFreebet>
                <S.FreebetFilters className="freebet-filters">

                <S.FreebetFiltersBtns>
                    <S.FilterBtn
                        isActive={(activeTab == 'active')}
                        onClick={onChangeFilter.bind(this, 'active')}>
                        {translation('account_freebets_activeFreebets')}
                    </S.FilterBtn>

                    <S.FilterBtn
                        isActive={(activeTab == 'history')}
                        onClick={onChangeFilter.bind(this, 'history')}>
                        {translation('account_freebets_historyFreebets')}
                    </S.FilterBtn>
                </S.FreebetFiltersBtns>

                {activeTab === 'history' ? (
                    <S.FreebetFiltersDates className="freebet-filters-dates">
                            <S.Datepicker>
                            <S.DateLabel>{translation('common_dateFrom')}</S.DateLabel>
                                <input type="date"
                                    value={calendarStartDate}
                                    disabled={(activeTab == 'active')}
                                    onChange={(event) => handleChangeStart(event.target.value)}
                                />
                                <S.DateIcon className="ion ion-ios-calendar-outline"></S.DateIcon>
                            </S.Datepicker>
                            <S.Datepicker>
                            <S.DateLabel>{translation('common_dateTo')}</S.DateLabel>
                                <input type="date"
                                    value={calendarEndDate}
                                    disabled={(activeTab == 'active')}
                                    onChange={(event) => handleChangeEnd(event.target.value)}
                                />
                                <S.DateIcon className="ion ion-ios-calendar-outline"></S.DateIcon>
                            </S.Datepicker>

                    </S.FreebetFiltersDates>
                ) : null}

            </S.FreebetFilters>

        <S.FreebetList>

            {isPending ?
                <Loader/>
                : (
                    <>
                             {activeTab == 'active' && (
                                    <S.FreebetActiveList className="freebet-active-list">
                                        <S.FreebetFakeTable>
                                            <S.Thead>
                                                <S.Tr>
                                                    <S.Th className="th freebet_id">
                                                        <span>{translation('account_freebets_freebetId')}</span>
                                                    </S.Th>
                                                    <S.Th className="th freebet_amount">
                                                        <span>{translation('account_freebets_freebetAmount')}</span>
                                                    </S.Th>
                                                    <S.Th className="th freebet_name">
                                                        <span>{translation('account_freebets_freebetName')}</span>
                                                    </S.Th>
                                                    <S.Th className="th freebet_expirationDate">
                                                        <span>{translation('account_freebets_freebetExpirationDate')}</span>
                                                    </S.Th>
                                                </S.Tr>
                                            </S.Thead>
                                            <S.Tbody>
                                                {activeFreebets ?
                                                    (<>
                                                        {_map(activeFreebetsData, ({validTo, nameKey, offerFreebetId, freebetStake}) => {
                                                            return (
                                                                <S.Tr className="row-flex" key={offerFreebetId}>
                                                                    <S.Td className="td freebet-id">
                                                                        <span>{offerFreebetId}</span>
                                                                    </S.Td>
                                                                    <S.Td className="td freebet-amount">
                                                                        <span
                                                                            className="amount">{freebetStake.toFixed(2)}</span>&nbsp;
                                                                        <span className="currency">{translation('common_pln')}</span></S.Td>
                                                                    <S.Td className="td freebet-name">
                                                                        <span>{translation(nameKey)}</span>
                                                                    </S.Td>
                                                                    <S.Td className="td freebet-expirationDate">
                                                                        <span>{formatDate(validTo, 'yyyy-MM-dd HH:mm')}</span>
                                                                    </S.Td>
                                                                </S.Tr>
                                                            )
                                                        })}

                                                    </>)
                                                    :
                                                    <S.NoResult>{translation('account_freebets_noActiveFreebets')}</S.NoResult>
                                                }
                                            </S.Tbody>
                                        </S.FreebetFakeTable>

                                    </S.FreebetActiveList>
                                )}
                                  {activeTab == 'history' && (
                                    <S.FreebetHistoryList className="freebet-history-list">
                                        <S.FreebetFakeTable>
                                            <S.Thead>
                                                <S.Tr>
                                                    <S.Th className="th freebet_id">
                                                        <span>{translation('account_freebets_freebetId')}</span>
                                                    </S.Th>
                                                    <S.Th className="th freebet_amount">
                                                        <span>{translation('account_freebets_freebetAmount')}</span>
                                                    </S.Th>
                                                    <S.Th className="th freebet_name">
                                                        <span>{translation('account_freebets_freebetName')}</span>
                                                    </S.Th>
                                                    <S.Th className="th freebet_expirationDate">
                                                        <span>{translation('account_freebets_freebetExpirationDate')}</span>
                                                    </S.Th>
                                                </S.Tr>
                                            </S.Thead>

                                            <S.Tbody>
                                                {_size(historyFreebetsData) ?
                                                    (<>
                                                        {_map(historyFreebetsData, ({validTo, nameKey, offerFreebetId, freebetStake}) => {
                                                            return (
                                                                <S.Tr className="row-flex" key={offerFreebetId}>
                                                                    <S.Td className="td freebet-id">
                                                                        <span>{offerFreebetId}</span>
                                                                    </S.Td>
                                                                    <S.Td className="td freebet-amount">
                                                                    <span
                                                                        className="amount">{freebetStake.toFixed(2)}</span>&nbsp;
                                                                        <span
                                                                            className="currency">{translation('common_pln')}</span></S.Td>
                                                                    <S.Td className="td freebet-name">
                                                                        <span>{translation(nameKey)}</span>
                                                                    </S.Td>
                                                                    <S.Td className="td freebet-expirationDate">
                                                                        <span>{formatDate(validTo, 'yyyy-MM-dd HH:mm')}</span>
                                                                    </S.Td>
                                                                </S.Tr>
                                                            )
                                                        })}

                                                        {_size(historyFreebetsData) > 0 && (
                                                            <Pagination
                                                                currentPage={_get(historyFreebets, 'currentPage')}
                                                                limit={limit} data={historyFreebetsData} isNextPageAvailable={historyFreebets.isNextPageAvailable}
                                                                callback={goPage}/>)}
                                                    </>)

                                                    :
                                                    <S.NoResult>{translation('account_freebets_noHistoryFreebets')}</S.NoResult>
                                                }

                                            </S.Tbody>

                                        </S.FreebetFakeTable>
                                    </S.FreebetHistoryList>
                                )}
                        
                    </>
                )
            }

        </S.FreebetList>

    </S.AccountFreebet>
    );
};

const mapStateToProps = ({AccountFreebet: {isPending, error, startDate, endDate, freebets, limit, activeTab}, Auth: {user: {currencyCode}}}, props) => {
    return {
        error,
        isPending,
        startDate,
        endDate,
        freebets,
        limit,
        currencyCode,
        activeTab
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeDateByType: bindActionCreators(changeDateByType, dispatch),
        fetchFreebetsByFilter: bindActionCreators(fetchFreebetsByFilter, dispatch),
        setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
        changeActiveTab: bindActionCreators(changeActiveTab, dispatch),
        resetToInitialState: bindActionCreators(resetToInitialState, dispatch),
        dispatch
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountFreebet);
